import { getServices } from "../../platform.js";

/** Device-local theme-sync state — NEVER backed up, NEVER synced (like the sync
 *  cursor/url). Lives in settings rows so it survives reloads on this device. */
const ENABLED_KEY = "theme_sync_enabled";
const BASE_KEY = "theme_sync_base"; // updated_at of the last theme we agreed on
const KEEP_KEY = "theme_conflict_keep"; // remote updated_at the user chose to keep-local against
const PRESET_CONFIRMED_KEY = "theme_preset_confirmed"; // user picked a preset at least once

const s = () => getServices().settings;

export async function loadThemeSyncEnabled(): Promise<boolean> {
  const v = await s().get(ENABLED_KEY);
  return v == null ? true : v !== "false";
}

export async function saveThemeSyncEnabled(on: boolean): Promise<void> {
  await s().set(ENABLED_KEY, String(on));
}

export async function loadThemeBaseVersion(): Promise<string | null> {
  return (await s().get(BASE_KEY)) || null;
}

export async function saveThemeBaseVersion(updatedAt: string): Promise<void> {
  await s().set(BASE_KEY, updatedAt);
}

export async function loadThemeConflictKeep(): Promise<string | null> {
  return (await s().get(KEEP_KEY)) || null;
}

export async function saveThemeConflictKeep(remoteVersion: string): Promise<void> {
  await s().set(KEEP_KEY, remoteVersion);
}

export async function clearThemeConflictKeep(): Promise<void> {
  await s().delete(KEEP_KEY);
}

/** Whether the user has ever explicitly picked a theme preset — once true, the
 *  theme settings page starts with the preset picker collapsed. */
export async function loadPresetConfirmed(): Promise<boolean> {
  return (await s().get(PRESET_CONFIRMED_KEY)) === "true";
}

export async function savePresetConfirmed(): Promise<void> {
  await s().set(PRESET_CONFIRMED_KEY, "true");
}

/** On sign-out: drop the agreed-base + conflict suppression so the next sign-in
 *  re-evaluates against the account's theme (the enabled toggle is kept). */
export async function clearThemeSyncCursor(): Promise<void> {
  await s().delete(BASE_KEY);
  await s().delete(KEEP_KEY);
}
